import { HTTPClient } from "@/utils/request.api";

export default {
  Elegibilidade: ({ payload }) =>
    HTTPClient.post("Sales/Elegibilidade", payload),
  Lead: ({ payload }) => HTTPClient.post("Sales/Lead", payload),
  Autenticacao: ({ payload }) => HTTPClient.post("Sales/Autenticacao", payload),
  ReenvioToken: ({ payload }) => HTTPClient.post("Sales/ReenvioToken", payload),
  ReenvioPagamento: ({ payload }) =>
    HTTPClient.post("Sales/ReenvioPagamento", payload),
  PagamentoBoleto: ({ payload }) =>
    HTTPClient.post("Sales/PagamentoBoleto", payload),
  AlterarProduto: ({ payload }) =>
    HTTPClient.post("Sales/AlterarProduto", payload),
};
